const orderList = [
    {
        id: "1",
        order_date: "22 Feb, 2023",
        delivery_date: "02 Mar, 2023",
        product: "Cotton collar tshirts for men",
        customer: "Deondre Fahey",
        shop: [{
            img: "assets/images/companies/img-6.png",
            name: "Ratke Group"
        }],
        pay_method: "COD",
        price: "$109.00",
        ratings: "-",
        delivery_status: "New"
    },
    {
        id: "2",
        order_date: "14 Feb, 2023",
        delivery_date: "27 Feb, 2023",
        product: "Like style travel black handbag",
        customer: "Warren Anderson",
        shop: [{
            img: "assets/images/companies/img-1.png",
            name: "Zibra Fashion"
        }],
        pay_method: "Mastercard",
        price: "$149.00",
        ratings: "4.5",
        delivery_status: "Pending"
    },
    {
        id: "3",
        order_date: "30 Jan, 2023",
        delivery_date: "10 Feb, 2023",
        product: "Fossil gen 5E smart watch",
        customer: "Dianna Bogan",
        shop: [{
            img: "assets/images/companies/img-2.png",
            name: "Brand Infosys"
        }],
        pay_method: "Visa",
        price: "$215.00",
        ratings: "4.9",
        delivery_status: "Out of Delivered"
    },
    {
        id: "4",
        order_date: "25 Jan, 2023",
        delivery_date: "03 Feb, 2023",
        product: "Super bass blutooth wireless headphone",
        customer: "Josefa Weissnat",
        shop: [{
            img: "assets/images/companies/img-3.png",
            name: "Brand Infosys"
        }],
        pay_method: "Mastercard",
        price: "$199.00",
        ratings: "4.3",
        delivery_status: "Shipping"
    },
    {
        id: "5",
        order_date: "19 Jan, 2023",
        delivery_date: "27 Jan, 2023",
        product: "Willage volleyball ball size 4",
        customer: "Ophelia Steuber",
        shop: [{
            img: "assets/images/companies/img-4.png",
            name: "aldawal"
        }],
        pay_method: "COD",
        price: "$330.00",
        ratings: "4.7",
        delivery_status: "Delivered"
    },
    {
        id: "6",
        order_date: "16 Jan, 2023",
        delivery_date: "19 Jan, 2023",
        product: "Branded T-Shirts",
        customer: "Federico Hand",
        shop: [{
            img: "assets/images/companies/img-5.png",
            name: "Zibra Fashion"
        }],
        pay_method: "Visa",
        price: "$745.11",
        ratings: "4.6",
        delivery_status: "Pending"
    },
    {
        id: "7",
        order_date: "01 Jan, 2023",
        delivery_date: "11 Jan, 2023",
        product: "Flip-Flops and house slippers",
        customer: "Uriel King",
        shop: [{
            img: "assets/images/companies/img-1.png",
            name: "Zibra Fashion"
        }],
        pay_method: "Mastercard",
        price: "$99.99",
        ratings: "4.9",
        delivery_status: "New"
    },
    {
        id: "8",
        order_date: "27 Dec, 2022",
        delivery_date: "02 Jan, 2023",
        product: "Flip-Flops and house slippers",
        customer: "Buck Roberts",
        shop: [{
            img: "assets/images/companies/img-6.png",
            name: "Ratke Group"
        }],
        pay_method: "Mastercard",
        price: "$150.00",
        ratings: "4.6",
        delivery_status: "Pending"
    },
    {
        id: "9",
        order_date: "22 Dec, 2022",
        delivery_date: "28 Dec, 2022",
        product: "Jeans blue men boxer",
        customer: "Axel Kozey",
        shop: [{
            img: "assets/images/companies/img-4.png",
            name: "aldawal"
        }],
        pay_method: "Visa",
        price: "$136.14",
        ratings: "4.6",
        delivery_status: "Pending"
    },
    {
        id: "10",
        order_date: "21 Dec, 2022",
        delivery_date: "29 Dec, 2022",
        product: "MAG back to the future shoes",
        customer: "Dallin Schowalter",
        shop: [{
            img: "assets/images/companies/img-3.png",
            name: "Brand Infosys"
        }],
        pay_method: "COD",
        price: "$179.99",
        ratings: "4.7",
        delivery_status: "Delivered"
    },
    {
        id: "11",
        order_date: "25 Jan, 2023",
        delivery_date: "03 Feb, 2023",
        product: "Super bass blutooth wireless headphone",
        customer: "Josefa Weissnat",
        shop: [{
            img: "assets/images/companies/img-3.png",
            name: "Brand Infosys"
        }],
        pay_method: "Mastercard",
        price: "$199.00",
        ratings: "4.3",
        delivery_status: "Shipping"
    },
    {
        id: "12",
        order_date: "01 Jan, 2023",
        delivery_date: "11 Jan, 2023",
        product: "Flip-Flops and house slippers",
        customer: "Uriel King",
        shop: [{
            img: "assets/images/companies/img-1.png",
            name: "Zibra Fashion"
        }],
        pay_method: "Mastercard",
        price: "$99.99",
        ratings: "4.9",
        delivery_status: "New"
    },
    {
        id: "13",
        order_date: "22 Feb, 2023",
        delivery_date: "02 March, 2023",
        product: "Cotton collar t-shirts for men",
        customer: "Deondre Fahey",
        shop: [{
            img: "assets/images/companies/img-7.png",
            name: "Pich Fashion"
        }],
        pay_method: "COD",
        price: "$109.00",
        ratings: "-",
        delivery_status: "New"
    }
]

export { orderList }